// Import the functions you need from the SDKs you need
import axios from 'axios'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: 'AIzaSyCbtZpUDMToZMefvdNKLS_23TwXKEzi2mQ',
  authDomain: 'pizzaservice2023.firebaseapp.com',
  projectId: 'pizzaservice2023',
  storageBucket: 'pizzaservice2023.appspot.com',
  messagingSenderId: '986871090885',
  appId: '1:986871090885:web:974b4c8384a8a26a0aaaac',
  measurementId: 'G-WEHLBWE80E'
}

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig)
const messaging = getMessaging(firebaseApp)
export { messaging }

export const getTokenFun = data => {
  return getToken(messaging, {
    vapidKey: 'BGkGZ49OB2hJBtGib9C-cdwaHrzR6v3bQ2Fa4gJo1lkQFLRIC5bUvco23S7kZ-K-EY1FDM8c-GjVCdzUa2u10QQ'
  })
    .then(currentToken => {
      if (currentToken) {
        let machineId = localStorage.getItem('MachineId')
        if (!machineId) {
          machineId = crypto.randomUUID()
          localStorage.setItem('MachineId', machineId)
        }
        function getDeviceType() {
          if (window.innerWidth <= 767) {
            return 'mobile'
          } else if (window.innerWidth <= 1024) {
            return 'tablet'
          } else {
            return 'desktop'
          }
        }

        const deviceType = getDeviceType()

        function getDeviceName() {
          const { userAgent } = window.navigator

          if (/Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
            return 'Mobile Device'
          } else if (/Tablet|iPad/i.test(userAgent)) {
            return 'Tablet'
          } else {
            return 'Desktop'
          }
        }

        const deviceName = getDeviceName()

        // console.log('current token for client: ', currentToken)
        axios
          .post(process.env.REACT_APP_BASE_URL + '/api/dashboard/superAdmin/notifications/update_fcm', {
            fcm_token: currentToken,
            device_id: machineId,
            device_type: deviceType,
            device_name: deviceName
          })
          .then(res => {
            // console.log(res)
          })
        // Perform any other neccessary action with the token
      } else {
        // Show permission request UI
        console.log('No registration token available. Request permission to generate one.')
      }
    })
    .catch(err => {
      console.log('An error occurred while retrieving token. ', err)
    })
}
export const onMessageListener = () =>
  new Promise(resolve => {
    onMessage(messaging, payload => {
      // console.log('payload', payload)
      resolve(payload)
    })
  })
